import withInputValidation, {
  TextValidations, DefaultRegexMessageMap,
} from '../../enhancers/hoc/withInputValidation';
import Input from './input';

const InputWithValidation = withInputValidation(Input);

export {
  InputWithValidation as default,
  TextValidations,
  DefaultRegexMessageMap,
};
